import { useState, useEffect } from "react";
import MailingService from "api/services/mailing";
import miscUtils from "utils/miscUtils";

export const useOnboardingEmailsSet = (groupData: any) => {
    const [type1Email, setType1Email] = useState<boolean>(false);
    const [type2Email, setType2Email] = useState<boolean>(false);

    useEffect(() => {
        if (miscUtils.isAdmin(groupData && groupData.user_membership)) {
            MailingService.getInstance()
                .getCustomEmailsList(groupData && groupData.id)
                .then((response: any) => {
                    if (response && response.data) {
                        setType1Email(response.data[0] && response.data[0].active)
                        setType2Email(response.data[1] && response.data[1].active)
                    }
                }).catch((error: any) => console.error(error))
        }
    }, [groupData]);

    if (type1Email && type2Email) {
        return true
    } else {
        return false
    }

};
